import React from 'react';
import Title from '../title/title.js';
import AdvisorSectionTitleLabel from '../advisor_section_title_label/advisor_section_title_label.js';
import classNames from '../../classnames.js';
import modules_14c8d388 from './advisor_section_short_descriptions.module.scss.js';

const AdvisorSectionShortDescriptions = ({ iconUrl, titleText, shortDescriptionsText, shortDescriptionsSubText, seeAllBtnOnClick, seeAllBtnText, loading }) => {
    const renderAdvisorSectionTitleLabel = () => (React.createElement(AdvisorSectionTitleLabel, { iconUrl: iconUrl, titleText: titleText, loading: loading }));
    const renderShortDescriptionsText = () => {
        if (!shortDescriptionsText && !loading)
            return null;
        return (React.createElement("div", { className: modules_14c8d388["advisor-section-short-descriptions-text-container"], "data-testid": "mbw-advisor-section-short-descriptions-text-container" },
            React.createElement(Title, { fontStyle: "heading-h5", ellipsis: true, maxRows: 5, loading: loading }, shortDescriptionsText)));
    };
    const renderShortDescriptionsSubText = () => {
        if (!shortDescriptionsSubText && !loading)
            return null;
        return (React.createElement("div", { className: modules_14c8d388["advisor-section-short-descriptions-sub-text-container"], "data-testid": "mbw-advisor-section-short-descriptions-sub-text-container" },
            React.createElement(Title, { fontStyle: "heading-h6", ellipsis: true, maxRows: 3, loading: loading }, shortDescriptionsSubText)));
    };
    const getSeeAllBtnContainerClassName = () => classNames(modules_14c8d388["advisor-section-short-descriptions-see-all-btn-container"], { [modules_14c8d388.skeleton]: loading });
    const renderSeeAllBtn = () => {
        if ((!seeAllBtnOnClick || !seeAllBtnText) && !loading)
            return null;
        return (React.createElement("div", { className: getSeeAllBtnContainerClassName(), "data-testid": "mbw-advisor-section-short-descriptions-see-all-btn-container", onClick: seeAllBtnOnClick },
            React.createElement(Title, { fontStyle: "content-default", bold: true, loading: loading }, seeAllBtnText)));
    };
    const renderAdvisorSectionShortDescriptions = () => (React.createElement("div", { className: modules_14c8d388["advisor-section-short-descriptions-container"] },
        renderAdvisorSectionTitleLabel(),
        renderShortDescriptionsText(),
        renderShortDescriptionsSubText(),
        renderSeeAllBtn()));
    return renderAdvisorSectionShortDescriptions();
};

export { AdvisorSectionShortDescriptions as default };
//# sourceMappingURL=advisor_section_short_descriptions.js.map
